export default __webpack_public_path__ + "media/images/brands/xpress/services/service-01-653242b9aa1b82ee9b8ca784789d1a87.jpg";